import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {BannersHttpService} from '../../../../../services/http-services/banners/banners-http.service';
import {GrBanner} from '../../../../../interfaces/banners-interfaces';

@Component({
  selector: 'gr-banners-in-app',
  templateUrl: './banners-in-app.component.html'
})
export class BannersInAppComponent implements OnInit, OnChanges {
  @Input() isBannerChange = false;
  @Output() bannerForEdit: EventEmitter<GrBanner> = new EventEmitter();
  @Output() bannerForDelete: EventEmitter<GrBanner> = new EventEmitter();
  bannersByPosition: any = [];
  bannerPositionArray = [
    {name: 'A', value: 1},
    {name: 'B', value: 2},
    {name: 'C', value: 3},
    {name: 'D', value: 4},
    {name: 'E', value: 5},
    {name: 'F', value: 6},
    {name: 'G', value: 7},
  ];

  constructor(private bannersHttpService: BannersHttpService) {
  }

  ngOnInit(): void {
    this.getBanners();
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.isBannerChange && changes.isBannerChange.currentValue) {
      this.getBanners();
    }
  }

  getBanners(): void {
    this.bannersHttpService.getBanners().then(res => {
      this.bannersByPosition = res.data;
    });
  }
}
